import { useMemo } from "react";
import { ChimneyDao } from './ChimneyDao';

export const useChimneyDao = (environment: string): ChimneyDao => {
  //const accessToken = useAccessToken();

  return useMemo(() => new ChimneyDao(environment), [environment]);
};
